import getConfig from 'next/config'

import { BrPageModel, getPlpPromotionSize } from '@grandvisionhq/bloomreach'
import { MediaQuery } from '@grandvisionhq/common'
import { AlgoliaConfigProviderProps, AlgoliaCrossSellConfig } from '@grandvisionhq/search'

const { algolia } = getConfig().publicRuntimeConfig

const algoliaOptions: AlgoliaConfigProviderProps['options'] = {
  appId: algolia.appId,
  apiKey: algolia.apiKey,
  indexName: algolia.productIndex.name,
  filters: algolia.productIndex.filters,
  sortIndices: algolia.productIndex.sortIndices,
  facets: algolia.productIndex.facets,
  pageSize: algolia.productIndex.pageSize,
}

export function getAlgoliaCrossSellConfig(productType: string): AlgoliaCrossSellConfig {
  const { appId, apiKey } = algoliaOptions
  const { name: indexName, facets } = algolia.crossSellIndex

  return { appId, apiKey, indexName, facets: facets[productType] || {} }
}

export function createAlgoliaConfig(
  clientQueryString: string,
  pageModel?: BrPageModel,
  mediaQueryBreakpoint?: MediaQuery.BreakpointName,
  additionalOptions?: Partial<AlgoliaConfigProviderProps['options']>
): Pick<AlgoliaConfigProviderProps, 'clientQueryString' | 'options' | 'isEnabled'> {
  const { plpPromotionSize } = getPlpPromotionSize(pageModel, mediaQueryBreakpoint)

  return {
    clientQueryString,
    options: {
      ...algoliaOptions,
      ...additionalOptions,
      pageSize: algoliaOptions.pageSize - (plpPromotionSize || 0),
    },
    isEnabled: true,
  }
}
